import React from 'react';
import './_sidebar.css';
import _ from 'lodash';
import { isEmpty } from 'lodash/fp';

const SearchField = ({value, onChange, onFocus, ...props}) => {

    const showSearch = isEmpty(value);

    return (
        <div className="sidebar-info sidebar-info-busca"> 
            {
                showSearch &&
                <img src={require('../../img/icons/search.png')} />
            }
            <input type="text"
                placeholder="Busca"
                name="busca"
                value={value}
                onFocus={onFocus}
                onChange={onChange} />
        </div>
    )
};

export default SearchField;


// WEBPACK FOOTER //
// ./src/components/sidebar/SearchField.js